module.exports = __webpack_public_path__ + "static/media/aadhaar1.ea23a964.png";